import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CheckboxModule } from "@openng/optimus-ui/checkbox";
import { TableModule } from "@openng/optimus-ui/table";
import { NotificationPermission } from "../../../../models/ui/permissionMatrix";

@Component({
  selector: "app-notification-permissions",
  standalone: true,
  imports: [CheckboxModule, FormsModule, TableModule, TranslateModule],
  host: { class: "block" },
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./notification-permissions.component.html",
})
export class NotificationPermissionsComponent {
  public permissions = input<NotificationPermission[]>([]);
  public disabled = input(false);
}
